import React, { useState } from "react";
import "./student-css.css";
import { OlympicResult } from "../../types/OlympicType";
import { searchStudent } from "../../services/StudentService";
import HeaderComponent from "../../component/HeaderComponent/HeaderComponent";

// import axios from "axios";

const StudentPage: React.FC = () => {
  const [studentName, setStudentName] = useState<string>("");
  const [birthday, setBirthday] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [olympicResults, setOlympicResults] = useState<OlympicResult[]>([]);
  const [isDisabled, setIsDisabled] = useState(true);
  // const fetchUserIP = async () => {
  //   try {
  //     const response = await axios.get("https://api.ipify.org?format=json");
  //     return response.data.ip; // Trả về địa chỉ IP
  //   } catch (error) {
  //     console.error("Không thể lấy địa chỉ IP:", error);
  //     return null;
  //   }
  // };

  // Hàm lấy thông tin thiết bị từ User-Agent
  // const getDeviceInfo = () => {
  //   const userAgent = navigator.userAgent;
  //   const platform = navigator.platform;

  //   return {
  //     userAgent,
  //     platform,
  //   };
  // };

  // const detectDeviceType = () => {
  //   const userAgent = navigator.userAgent.toLowerCase();

  //   if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) {
  //     return "Mobile";
  //   } else {
  //     return "Desktop";
  //   }
  // };

  const handleStudentSearch = async () => {
    setLoading(true);
    setError(null);
    setHasSearched(true);

    try {
      if (!studentName.trim() || !birthday.trim()) {
        setError("Vui lòng nhập tên sinh viên và ngày sinh để tìm kiếm");
        return;
      }
      // const userIp = await fetchUserIP();
      // const deviceInfo = getDeviceInfo();
      // const getdetectDeviceType = detectDeviceType();
      const res = await searchStudent(studentName, birthday);
      // console.log("userIp ", userIp);
      // console.log("deviceInfo ", deviceInfo);
      // console.log("detectDeviceType ", getdetectDeviceType);
      if (res.content && res.content.length > 0) {
        setOlympicResults(res.content);
      } else {
        setOlympicResults([]);
        setError("Không có dữ liệu cho sinh viên này.");
      }
    } catch (error) {
      console.error("Error searching:", error);
      setError("Có lỗi xảy ra trong quá trình tìm kiếm. Vui lòng thử lại.");
      setOlympicResults([]); // Xóa kết quả khi có lỗi xảy ra
    } finally {
      setLoading(false);
    }
  };

  const renderStudentResults = () => {
    if (!hasSearched) return null;
    if (!olympicResults.length) return <p>Không có dữ liệu.</p>;

    return (
      <>
        {/* Bảng lớn cho thiết bị lớn */}
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Số báo danh</th>
                <th>Họ và Tên</th>
                <th>Ngày sinh</th>
                <th>Nơi sinh</th>
                <th>Trường THPT</th>
                <th>Môn thi</th>
                <th>Thời gian thi</th>
                <th>Phòng thi</th>
                <th>Địa điểm</th>
                <th>Trạng thái</th>
                <th>Lý do</th>
                <th>Điểm</th>
                <th>Kết quả</th>
              </tr>
            </thead>
            <tbody>
              {olympicResults.map((result, index) => (
                <tr key={index}>
                  <td>{result.studentCode}</td>
                  <td>{result.fullName}</td>
                  <td>{result.birthday}</td>
                  <td>{result.place}</td>
                  <td>{result.highSchool}</td>
                  <td>{result.monThi}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{result.timeExam}</td>
                  <td>{result.roomExam}</td>
                  <td>{result.locationExam}</td>
                  <td>
                    <span
                      className={`status-badge ${
                        result.status === 1 ? "active" : "inactive"
                      }`}
                    >
                      {result.status === 1
                        ? "Đủ điều kiện dự thi"
                        : "Không đủ điều kiện dự thi"}
                    </span>
                  </td>
                  <td>{result.reason}</td>
                  <td>{result.point}</td>
                  <td>{result.result}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Bảng dọc cho thiết bị di động */}
        <div className="mobile-table">
          {olympicResults.map((result, index) => (
            <div className="mobile-row" key={index}>
              <div className="mobile-col">
                <strong>Số báo danh:</strong>
              </div>
              <div className="mobile-col">{result.studentCode}</div>
              <div className="mobile-col">
                <strong>Họ và Tên:</strong>
              </div>
              <div className="mobile-col">{result.fullName}</div>
              <div className="mobile-col">
                <strong>Ngày sinh:</strong>
              </div>
              <div className="mobile-col">{result.birthday}</div>
              <div className="mobile-col">
                <strong>Nơi sinh:</strong>
              </div>
              <div className="mobile-col">{result.place}</div>
              <div className="mobile-col">
                <strong>Trường THPT:</strong>
              </div>
              <div className="mobile-col">{result.highSchool}</div>
              <div className="mobile-col">
                <strong>Môn thi:</strong>
              </div>
              <div className="mobile-col">{result.monThi}</div>
              <div className="mobile-col">
                <strong>Thời gian thi:</strong>
              </div>
              <div className="mobile-col">{result.timeExam}</div>
              <div className="mobile-col">
                <strong>Phòng thi:</strong>
              </div>
              <div className="mobile-col">{result.roomExam}</div>
              <div className="mobile-col">
                <strong>Địa điểm:</strong>
              </div>
              <div className="mobile-col">{result.locationExam}</div>
              <div className="mobile-col">
                <strong>Trạng thái:</strong>
              </div>
              <div className="mobile-col">
                <span
                  className={`status-badge ${
                    result.status === 1 ? "active" : "inactive"
                  }`}
                >
                  {result.status === 1
                    ? "Đủ điều kiện dự thi"
                    : "Không đủ điều kiện dự thi"}
                </span>
              </div>
              <div className="mobile-col">
                <strong>Lý do:</strong>
              </div>
              <div className="mobile-col">{result.reason}</div>
              <div className="mobile-col">
                <strong>Điểm:</strong>
              </div>
              <div className="mobile-col">{result.point}</div>
              <div className="mobile-col">
                <strong>Kết quả:</strong>
              </div>
              <div className="mobile-col">{result.result}</div>
            </div>
          ))}
        </div>
      </>
    );
  };

  const formatDate = (value: string) => {
    // Loại bỏ các ký tự không phải số
    value = value.replace(/\D/g, "");

    // Lấy ngày, tháng và năm từ chuỗi
    let day = value.slice(0, 2);
    let month = value.slice(2, 4);
    let year = value.slice(4, 8);

    // Kết hợp ngày, tháng và năm với dấu "/"
    let formattedDate = [day, month, year].filter(Boolean).join("/");

    return formattedDate;
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatDate(e.target.value);
    setBirthday(formattedValue);
    setError(null);
  };

  return (
    <>
      <HeaderComponent />
      <div style={{ marginTop: 10 }} className="student-interface">
        <div className="search">
          <input
            type="text"
            placeholder={error ? error : "Nhập Họ và tên vd: Nguyễn Văn A"}
            value={studentName}
            onChange={(e) => {
              setStudentName(e.target.value);
              setError(null);
            }}
          />
          <input
            type="text"
            value={birthday}
            onChange={handleDateChange}
            placeholder="Ngày sinh (dd/mm/yyyy)"
            className={error ? "error-input" : ""}
            maxLength={10} // Giới hạn ký tự nhập vào
          />
          <button onClick={handleStudentSearch}>Tìm kiếm</button>
          {/* <button onClick={handleStudentSearch} disabled={isDisabled}>
            Tìm kiếm
          </button> */}
        </div>
        {/* <h1>Đang cập nhập</h1> */}

        {renderStudentResults()}
      </div>

      <div className="notice-section">
        <strong>Lưu ý:</strong>
        <ul>
          <li>
            1. Thí sinh đọc kỹ Thông báo số 5{" "}
            <a
              href="https://uet.vnu.edu.vn/category/olympic-thpt-vnu-2024-2025/"
              target="_blank"
              rel="noopener noreferrer"
            >
              TẠI ĐÂY
            </a>
          </li>
          <li>
            2. Thông tin liên hệ: Hotline: 0334 924 224; Email:{" "}
            <a href="mailto:UET_OlympicVNU@vnu.edu.vn">
              UET_OlympicVNU@vnu.edu.vn
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default StudentPage;
